var _rect, _rect2, _rect3, _rect4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompactNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 33,
    viewBox: "0 0 47 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.85156,
    y: 6.62891,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.85156,
    y: 11.6797,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.85156,
    y: 16.7324,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.85156,
    y: 21.7852,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 14.0593L4.17827 11.369L1.07173 11.369L2.625 14.0593ZM2.35597 7.06445L2.35597 11.638L2.89403 11.638L2.89403 7.06445L2.35597 7.06445Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 18.4524L1.07173 21.1427H4.17827L2.625 18.4524ZM2.89403 25.4473L2.89403 20.8737H2.35597L2.35597 25.4473H2.89403Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompactNew);
export default __webpack_public_path__ + "static/media/Compact_New.43a9d92533f9663704cad7bcea78e4ba.svg";
export { ForwardRef as ReactComponent };